import DOMPurify from "dompurify";

/**
 * Sanitizes HTML string using DOMPurify to prevent XSS.
 * Only allows safe formatting tags — no scripts, iframes, event handlers.
 */
const ALLOWED_TAGS = [
  "p", "br", "strong", "b", "em", "i", "u", "s",
  "h1", "h2", "h3", "h4", "h5", "h6",
  "ul", "ol", "li",
  "a", "blockquote", "pre", "code",
  "span", "div",
];

const ALLOWED_ATTR = ["href", "target", "rel", "class"];

export const sanitizeHtml = (html) => {
  if (typeof html !== "string") return "";
  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS,
    ALLOWED_ATTR,
    FORCE_BODY: false,
  });
};
